import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { api } from "@/lib/api";

const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section id="testimoni" className="relative bg-[#050505] py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
          <div>
            <span className="font-body text-xs uppercase tracking-[0.3em] text-gradient-wl font-semibold">Testimoni</span>
            <h2 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter mt-3 leading-none">
              Dipercaya ribuan <br /> pelanggan.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: (i % 4) * 0.1 }}
              data-testid={`testimonial-${t.id}`}
              className="clip-frame rounded-2xl bg-[#0f0f0f] p-6 flex flex-col"
            >
              <Quote className="w-8 h-8 text-accent-wl mb-4" />
              <p className="font-body text-white/80 leading-relaxed flex-1">&ldquo;{t.quote}&rdquo;</p>
              <div className="flex gap-1 mt-5">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-accent-wl text-accent-wl" />
                ))}
              </div>
              <div className="flex items-center gap-3 mt-5 pt-5 border-t border-white/10">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
                <div>
                  <div className="font-body font-semibold text-white text-sm">{t.name}</div>
                  <div className="font-body text-xs text-white/40">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
